import Head from "next/head";
import type {NextPage} from "next";
import {useCookies} from "react-cookie";
import {handleLogout} from "components/utils"; import React, {useState} from "react";
import {ClientIndependentView} from "../components/client/self/ClientIndependentView";
import {ClientSettingsView} from "../components/client/self/ClientSettingsView";

const ClientSettings: NextPage = (props) => {

    const [cookies, setCookie] = useCookies(['qme']);
    const cookieQr = cookies.qme ? cookies.qme["qr"] : null
    const cookieEntityQr = cookies.qme ? cookies.qme["entity_qr"] : null

    return (
        <div>
            <Head>
                <title>QMe - Doctor&apos;s Settings</title>
                <meta name="description" content="QMe - Doctor's Settings"/>
                <meta name="keywords" content="hospital information system, hospital information management system"/>
                <meta name="robots" content="noindex, nofollow"/>
            </Head>
            <div className="row bg-white">

                <div className="px-3">
                    <ClientSettingsView cookieEntityQr={cookieEntityQr} cookieQr={cookieQr}/>
                </div>
            </div>

        </div>
    );
};


export default ClientSettings;
